import React, { useCallback, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import OrientationPrompt from "../components/OrientationPrompt";
import ResetTasksFlow from "../components/ResetTasksFlow";
import { isTeacher } from "../utils/auth";

function ResettingTasks() {
  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [name, setName] = useState("User");
  const [teacherid, setTeacherid] = useState(null);
  const teacherMode = isTeacher();

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  const handleUserLoaded = useCallback((user) => {
    setName(user.name);
    setTeacherid(user.teacherid);
  }, []);

  return (
    <div>
      <Container fluid className="vh-100">
        <HeadingBanner
          name={`Welcome ${name}!`}
          isLoggedIn={true}
          cloud={true}
          teacherid={teacherid}
        />

        <Row className="h-100">
          <LeftPanel />

          <Col
            sm={{ span: 10, offset: 2 }}
            className="blue-background d-flex flex-column justify-content-start align-items-center"
          >
            <div className="w-75 mt-4 mb-3">
              <h2 className="text-white">Reset Student Tasks</h2>
              <p className="text-white">
                {teacherMode
                  ? "Reset individual tasks or entire assessments for students in your school"
                  : "Reset individual tasks or entire assessments for students"}
              </p>
            </div>

            <ResetTasksFlow
              teacherMode={teacherMode}
              onUserLoaded={handleUserLoaded}
            />
          </Col>
        </Row>
      </Container>

      {isPortrait && <OrientationPrompt />}
    </div>
  );
}

export default ResettingTasks;
